import AboutSection from './AboutSection';

const Chef = () => {
    return (
        <div className='flex-grow px-[5%] pt-[3%] pb-20'>
           <AboutSection/>
        </div>
    )
}

export default Chef